import { Phone, Mail, Clock, MapPin } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import QuoteForm from "../components/QuoteForm";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHeader
        overline="Free survey"
        title="Request your free home survey"
        subtitle="Tell us a little about your home and we'll arrange a no-obligation survey and check exactly what funding you qualify for."
      />

      <section className="py-16 md:py-24 bg-brand-cream">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-5 gap-10 lg:gap-16">
          <Reveal className="lg:col-span-2">
            <h2 className="font-outfit text-2xl font-semibold text-brand mb-4">Get in touch</h2>
            <p className="font-figtree text-stone-600 mb-8">Prefer to talk? Our friendly team is here to answer your questions and book your survey.</p>
            <ul className="space-y-5">
              <li className="flex gap-4">
                <span className="w-11 h-11 rounded-xl bg-white border border-stone-200 flex items-center justify-center"><Phone className="w-5 h-5 text-brand-accent" /></span>
                <div><p className="font-outfit font-medium text-brand">Call us</p><p className="font-figtree text-stone-600">+44 7879 320060</p></div>
              </li>
              <li className="flex gap-4">
                <span className="w-11 h-11 rounded-xl bg-white border border-stone-200 flex items-center justify-center"><Mail className="w-5 h-5 text-brand-accent" /></span>
                <div><p className="font-outfit font-medium text-brand">Email us</p><p className="font-figtree text-stone-600">info@networksurveyltd.uk</p></div>
              </li>
              <li className="flex gap-4">
                <span className="w-11 h-11 rounded-xl bg-white border border-stone-200 flex items-center justify-center"><MapPin className="w-5 h-5 text-brand-accent" /></span>
                <div><p className="font-outfit font-medium text-brand">Visit us</p><p className="font-figtree text-stone-600">30 Runfold Avenue, Luton, LU3 2EH</p></div>
              </li>
              <li className="flex gap-4">
                <span className="w-11 h-11 rounded-xl bg-white border border-stone-200 flex items-center justify-center"><Clock className="w-5 h-5 text-brand-accent" /></span>
                <div><p className="font-outfit font-medium text-brand">Opening hours</p><p className="font-figtree text-stone-600">Mon–Fri 8am–7pm · Sat 9am–4pm</p></div>
              </li>
            </ul>
            <div className="mt-8 bg-brand rounded-2xl p-6 relative overflow-hidden">
              <div className="absolute inset-0 grain-overlay" />
              <p className="font-outfit text-brand-cream font-semibold text-lg relative">No upfront cost. No obligation.</p>
              <p className="font-figtree text-brand-cream/70 text-sm mt-1 relative">We'll always be upfront about grants, finance and any costs involved.</p>
            </div>
          </Reveal>

          <div className="lg:col-span-3">
            <QuoteForm />
          </div>
        </div>
      </section>
    </div>
  );
}
